module.exports = __webpack_public_path__ + "img/fig28.07768d15.jpg";